export enum TRACK_TYPE {
  CLICK = 'click',
  VIEW = 'view',
  API_ERROR = 'api_error',
  API_SUCCESS = 'api_success',
}

export enum CATEGORY {
  AUTH = 'auth',
  BILLING = 'billing',
  DESTINATION = 'destination',
  SIDEBAR = 'sidebar',
  DIRECTORY = 'directory',
  PROFILE = 'profile',
  EVENT_LIMIT = 'Event Limit Page viewed',
  MODEL = 'SQL model',
  SOURCE_ONBOARDING = 'Source onboarding',
}

export const BI_EVENTS = {
  // Auth
  LOGIN: 'Login',
  PRIVACY_POLICY: 'privacy_policy',
  TERMS_OF_SERVICE: 'terms_of_service',
  SIGNED_UP: 'ads_cnv_app_signup',
  SIGNED_UP1: 'User Signed Up',
  USER_OPERATION_FAILURE: 'set user operation failed',
  SIGN_UP_WITH_EMAIL: 'Signup with email',
  // SIDEBAR
  Connections: 'Connections',
  Sources: 'Sources',
  Destinations: 'Destinations',
  Syncs: 'Syncs',
  Directory: 'Directory',
  Transformations: 'Transformations',
  Teammates: 'Teammates',
  'Audit Logs': 'Audit Logs',
  Metrics: 'Metrics',
  // Directory
  DESTINATION_CLICK: 'Destination clicked',

  // Billing
  UPGRADE_PLAN: 'Upgrade Plan clicked',
  PRICING_BREAKDOWN: 'Billing view pricing breakdown',
  PROFILE_CLICKED: 'Profile Clicked',
  // Destination
  NEW_DEST: 'new destination created',
  INTEGRATION_REQUEST: 'New Integration requested',

  // PROFILE
  UpdateName: 'General name updated successfully',
  UpdateNameFailure: 'General name update failure',
  UpdatePassword: 'General password updated successfully',
  PasswordFailure: 'General password update failure',
  // Event Limit
  EventLimit: 'Event limit page viewed',
  AdminUpgradeClick: 'Request Admin to upgrade clicked',
  AdminUpgradeSent: 'Request Admin to upgrade sent',
  AdminUpgradeFailed: 'Request Admin to upgrade failed',
  ContinueToApp: 'Continue to App clicked',
  ExplorePlans: 'Explore Plans Clicked',
  Sales: 'Chat with Sales clicked',
  Pro: 'RudderStack Pro clicked',
  // Onboarding
  SAMPLE_SOURCE: 'Sample source viewed',
  LIVE_EVENTS_BUTTON: 'Live events button viewed',
  SEND_EVENT_CURL: 'Curl command viewed',
  LIVE_EVENTS: 'Live events viewed',

  // SQL Model
  NEW_MODEL: 'New SQL model created',
  DELETE_MODEL: 'SQL model is deleted',
  USE_MODEL: 'New SQL model is being used in connection',
};
